import React from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserFriends,
  faChartLine,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";

import * as svgIcons from "@fortawesome/free-solid-svg-icons";

import commoditiesDuck from "data-handler/ducks/commodities";

import styles from "./styles.module.scss";
import { useSelector } from "react-redux";

const faBeans = ({
  prefix: "fas",
  iconName: "beans",
  icon: [
    430,
    430,
    [],
    "f0f9",
    "M159.66,173.05 C93.59,-3.1 319.66,-66.9 351.19,88.52 C352.58,101.2 355.53,108.14 362.44,115.05 C369.35,121.96 376.29,124.91 388.97,126.3 C433.01,131.15 468.71,166 475.79,211 C476.756498,217.000574 472.675574,222.648502 466.675,223.615 C460.674426,224.581498 455.026498,220.500574 454.06,214.5 C434.26,131.91 381.28,163.6 346.88,130.69 C336.32,120.15 331.26,108.66 329.32,91 C302.76,-31.31 128.52,20.45 178.42,160.31 C272,113.52 352.28,209 323.74,301.23 C376.18,320.52 445.85,295.5 453.85,240.85 C454.897004,234.870779 460.58958,230.869865 466.57,231.91 C469.445391,232.410385 472.004051,234.032979 473.682667,236.420553 C475.361282,238.808126 476.022232,241.764931 475.52,244.64 C463.88,315.15 380.36,344.99 316.97,322.15 C287.92,400.35 192.43,479.84 112.43,477.49 C-20.75,479 -42.92,297 88.12,274.23 C145.24,267.74 108.66,213.52 159.66,173.05 Z M226.57,170.37 C185.94,170.37 152.06,199.85 147.77,238.85 C145.83,256.53 140.74,267.97 130.21,278.53 C119.68,289.09 108.18,294.15 90.52,296.09 C47.75,299.84 16.1,344.09 22.82,386.09 C46.54,489.73 181.68,462.95 243.76,392.09 C318.8,328.81 340.56,179.92 226.57,170.37 Z M155.72,239.73 C156.385006,233.694771 161.81425,229.339738 167.85,230 C170.754019,230.316745 173.41278,231.775616 175.239952,234.054891 C177.067123,236.334166 177.912625,239.246629 177.59,242.15 C172.94,289.47 139.97,322 92.59,326 C79.08,326.26 78,305.24 91.4,304.06 C128.26,300.29 151.95,276.59 155.72,239.73 Z M179.15,195.86 C189.53,185.79 234.46,165.11 237.57,189.37 C237.57,195.445132 232.645132,200.37 226.57,200.37 C214.432012,200.360409 202.689828,204.687036 193.46,212.57 C191.46744,214.273962 188.93179,215.210202 186.31,215.21 C176.4,215.56 171.39,202.03 179.15,195.86 Z M309.22,82.11 C328.82,80.45 316.1,114.46 341.22,136.3 C352.85,147.93 366.57,154.06 385.69,156.16 C399.16,157.38 398,178.37 384.5,178.1 C337.11,174.09 304.15,141.57 299.49,94.24 C298.829738,88.20425 303.184771,82.7750056 309.22,82.11 Z M250.52,30.49 C265,29.58 312.55,43 299.15,63.48 C297.253784,65.6973387 294.554351,67.0705308 291.645617,67.2974533 C288.736883,67.5243758 285.857149,66.5864378 283.64,64.69 C274.407105,56.805571 262.66127,52.4789049 250.52,52.49 C236.26,52.69 236.24,30.28 250.52,30.49 Z",
  ],
} as unknown) as IconDefinition;

type IconDefinitionLookup = { [iconName: string]: IconDefinition };
const customIconDefinitions: IconDefinitionLookup = {
  faBeans,
};
const defaultIconDefinition = svgIcons.faQuestion;

const getIconDefinition = (iconName: string): IconDefinition =>
  customIconDefinitions[iconName] ||
  ((svgIcons as unknown) as IconDefinitionLookup)[iconName] ||
  defaultIconDefinition;

type SidebarIconProps = {
  commodity: number;
  selected: boolean;
};

export const SidebarIconAttendance: React.ComponentType<{}> = () => (
  <div
    className={classNames("date-icon", styles.dateIcon, styles.dateIconIsIcon)}
  >
    {<FontAwesomeIcon icon={faChartLine} size="2x" />}
  </div>
);

export const SidebarIconEnrolment: React.ComponentType<{}> = () => (
  <div className={classNames("date-icon", styles.dateIcon)}>
    {<FontAwesomeIcon icon={faUserFriends} size="2x" />}
  </div>
);

export const SidebarIcon: React.ComponentType<SidebarIconProps> = ({
  commodity,
  selected,
}) => {
  const commoditiesIndex = useSelector(commoditiesDuck.getIndex);

  const deviceOverviewIconClasses = classNames(
    "date-icon",
    styles.dateIcon,
    styles.dateIconIsIcon,
    {
      [styles.dateIconSelected]: selected,
    }
  );

  const commodityIconName: string =
    commoditiesIndex[commodity] && commoditiesIndex[commodity].icon_fa;

  const icon = (
    <FontAwesomeIcon icon={getIconDefinition(commodityIconName)} size="2x" />
  );

  return <div className={deviceOverviewIconClasses}>{icon}</div>;
};
